import { DetailedHTMLProps, MetaHTMLAttributes } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { concat, join } from "lodash";

const Seo = ({
  title,
  description,
  article,
  titleTemplate,
  keywords,
}: Props) => {
  const { pathname } = useLocation();

  const {
    defaultTitle,
    defaultTitleTemplate,
    defaultDescription,
    siteUrl,
    defaultImage,
    defaultKeywords,
  } = {
    defaultTitle: `Felix na Bolsa`,
    defaultTitleTemplate: `%s · Atenda centenas de investidores em poucos minutos por mês`,
    defaultDescription: `Automatize os cálculos de IR dos seus clientes investidores com a nossa calculadora de IR sobre Renda Variável pensada para escritórios de contabilidade.`,
    siteUrl: process.env.URL,
    defaultImage: `/images/logo/logosociais.jpg`,
    defaultKeywords: [
      `calculadora de ir`,
      `calculadora de ir ações`,
      `calculadora imposto de renda ações`,
      `calculadora imposto de renda grátis`,
      `calculadora ir ações`,
      `calculadora ir bolsa`,
      `calculadora ir day trade`,
      `ir bolsa`,
      `declaração de ações`,
      `B3`,
      `ReVar`,
      `CFI`,
      `Controle Fiscal para Investidores`,
    ],
  };

  const seo = {
    title: title || defaultTitle,
    titleTemplate: titleTemplate || defaultTitleTemplate,
    description: description || defaultDescription,
    image: `${siteUrl}${defaultImage}`,
    url: `${siteUrl}${pathname}`,
    keywords: concat(defaultKeywords, keywords),
  };

  let meta: DetailedHTMLProps<
    MetaHTMLAttributes<HTMLMetaElement>,
    HTMLMetaElement
  >[] = [
    { name: "description", content: seo.description },
    { name: "keywords", content: join(seo.keywords, ",") },
    { name: "image", content: seo.image },

    { property: "twitter:url", content: seo.url },
    { name: "twitter:card", content: "summary_large_image" },
    { name: `twitter:title`, content: title },
    { name: `twitter:description`, content: seo.description },
    { name: `twitter:image`, content: seo.image },
    {
      name: `twitter:image:alt`,
      content: `${siteUrl}${defaultImage}`,
    },
    { name: `twitter:site`, content: "@felixnabolsa" },

    { property: `og:type`, content: article ? "article" : "website" },
    { property: `og:url`, content: seo.url },
    { property: `og:title`, content: title },
    { property: `og:description`, content: seo.description },
    { property: `og:image`, content: seo.image },
    { property: `og:image:alt`, content: `${siteUrl}${defaultImage}` },
  ];

  return (
    <Helmet title={seo.title} titleTemplate={seo.titleTemplate} meta={meta} />
  );
};

export default Seo;

type Props = {
  title: string;
  titleTemplate: string;
  description: string;
  article?: boolean;
  keywords?: string[];
};
